import { SAAS_CONFIRM, SAAS_CONFIRM_SUCCESS, SAAS_CONFIRM_ERROR, SAAS_CONFIRM_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SaasConfirm = (state = initialState, action) => {
  switch (action.type) {
    case SAAS_CONFIRM:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SAAS_CONFIRM_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SAAS_CONFIRM_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SAAS_CONFIRM_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SaasConfirm;
